import { useEffect } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

interface LegalPageLayoutProps {
  title: string;
  subtitle: string;
  /** Omitted while the document is still loading; the line is hidden then. */
  lastUpdated?: string;
  children: React.ReactNode;
}

export function LegalPageLayout({ title, subtitle, lastUpdated, children }: LegalPageLayoutProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-bg-deep flex flex-col">
      <Navbar />

      <main className="flex-1 pt-28 pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="mb-12">
            <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">{title}</h1>
            <p className="text-text-secondary text-base">{subtitle}</p>
            {lastUpdated ? (
              <p className="text-text-tertiary text-sm mt-1">Last Updated: {lastUpdated}</p>
            ) : null}
          </div>

          {/* Content */}
          <div className="legal-content space-y-8">
            {children}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
